// ClassList.js
import { X } from 'lucide-react';
import React from 'react';

const ClassList = ({ classes, setSelectedClass, selectedClass, setClasses }) => {

    const sortedClasses = classes.sort((a, b) => a?.fields?.order - b?.fields?.order);

    return (
        <div>
            <div className='flex flex-row justify-between items-center mb-4'>
                <h2 className="text-lg font-bold">Classes</h2>
                <button className="btn btn-ghost btn-square" onClick={() => {
                    setClasses([]);
                }}>
                    <X />
                </button>
            </div>
            <ul className="space-y-4">
                {sortedClasses.map((classItem, index) => (
                    <li key={index}>
                        <button
                            className={`btn h-auto py-2 text-left w-full leading-[1.1] ${selectedClass?.sys?.id === classItem.sys.id ? 'bg-[#00449c] text-white' : null}`}
                            onClick={() => setSelectedClass(classItem)}
                        >
                            {classItem.fields.title || 'Untitled Class'}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ClassList;
